import styled from 'styled-components';

function getUnderline({ underline }) {
  if (underline) return 'underline';

  return 'none';
}

function getWeight({ bold, thin }) {
  if (bold) return 'bold';

  if (thin) return 300;

  return 'normal';
}

function getCursor({ pointer }) {
  if (pointer) return 'pointer';

  return 'normal';
}

const Span = styled.span`
  cursor: ${getCursor};
  font-weight: ${getWeight};
  text-decoration: ${getUnderline};
`;

export default Span;
